import { Injectable } from "@angular/core";
import { GoogleGeocodingApi } from "./google-geocoding.api";
import { map, Observable } from "rxjs";
import { GoogleGeocodingSerializer } from "./google-geocoding.serializer";
import { CitySuggestion, SimpleLocation } from "./google-geocoding.types";

@Injectable({ providedIn: "root" })
export class GoogleGeocodingService {
  constructor(private googleGeocodingApi: GoogleGeocodingApi, private serializer: GoogleGeocodingSerializer) {}

  decodeAddress(address: string, locale?:string): Observable<SimpleLocation> {
    return this.googleGeocodingApi
      .decodeAddress(address, 'de')
      .pipe(map((results) => this.serializer.deserializeGeocoderResult(results[0])));
  }

  decodeAddresses(address: string, locale?: string): Observable<Array<SimpleLocation>> {
    return this.googleGeocodingApi
      .decodeAddress(address, 'de')
      .pipe(map((results) => results.map((result) => this.serializer.deserializeGeocoderResult(result))));
  }

  searchCities(query: string, countryCode?: string): Observable<Array<CitySuggestion>> {
    return this.googleGeocodingApi.searchCities(query, countryCode).pipe(
      map((predictions) => predictions.map((prediction) => ({
        placeId: prediction.place_id,
        city: prediction.structured_formatting?.main_text || prediction.description,
        label: prediction.description,
        country: prediction.terms?.length ? prediction.terms[prediction.terms.length - 1].value : undefined,
      }))),
    );
  }
}
